import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'app/core/services/auth.service';
import { AuthUtils } from 'app/core/utils/auth.utils';
import { ForbiddenAccessHandler } from './forbidden-access.handler';
import { SKIP_FORBIDDEN_REDIRECT } from './http-context.tokens';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);
  private readonly forbiddenAccessHandler = inject(ForbiddenAccessHandler);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = req.clone();

    if (this.authService.accessToken && !AuthUtils.isTokenExpired(this.authService.accessToken)) {
      newReq = req.clone({
        headers: req.headers.set('Authorization', 'Token ' + this.authService.accessToken),
      });
    }

    return next.handle(newReq).pipe(
      catchError((error) => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => error);
        }

        if (error.status === 401 && !error.url?.endsWith('authenticate')) {
          this.authService.signOut();
          location.reload();
        }

        if (this.shouldHandleForbidden(error, req)) {
          this.forbiddenAccessHandler.handle();
        }

        return throwError(() => error);
      }),
    );
  }

  private shouldHandleForbidden(error: HttpErrorResponse, req: HttpRequest<any>): boolean {
    if (error.status !== 403) {
      return false;
    }

    if (req.context.get(SKIP_FORBIDDEN_REDIRECT)) {
      return false;
    }

    if (error.url?.endsWith('authenticate')) {
      return false;
    }

    return true;
  }
}
